/**
 * AG Grid comparator that sorts numbers ascending but always keeps no-data rows (null) at the
 * bottom, regardless of sort direction. A blank cell is "no data", not a 0 value, so it must not
 * rank among real values. AG Grid negates the comparator's result for descending sorts, so the
 * `isDescending` flag is used to flip the null handling and keep nulls last both ways.
 * Exported for unit testing; wired as the comparator for the numeric blotter columns.
 */
export function nullsLastNumericComparator(
  a: number | null,
  b: number | null,
  _nodeA: unknown,
  _nodeB: unknown,
  isDescending: boolean
): number {
  if (a == null && b == null) {
    return 0;
  }
  if (a == null) {
    return isDescending ? -1 : 1;
  }
  if (b == null) {
    return isDescending ? 1 : -1;
  }
  return a - b;
}
